

"use strict";

Shopify.theme.jsFeaturedCollection = {
  init: function init($section) {


    //var currentSection = $('.featured-collection-section section .featured-collection-wrapper');

    // Add settings from schema to current object
    // Selectors
    //var $prevButton = $section.find('.featured-collection__nav--prev');
    //var $nextButton = $section.find('.featured-collection__nav--next');
    var $featuredColSlider = $section.find('[data-featured-collection-slider]');
    //var $featuredColSlider = currentSection.find('[data-featured-collection-slider]');


    var $featuredCollectionSlider = $featuredColSlider.slick({
      slidesToShow: 3,
      slidesToScroll: 1,
      arrows: true,
      fade: false,
      rows: 0,
      infinite: false/*,
      centerMode:true*/

      ,responsive: [
        {
          breakpoint: 798,
          settings: {
            slidesToShow: 1,
            infinite: true,
            dots: true,
            arrows: false
          }
        }
      ]
    });
  },
  blockSelect: function blockSelect($section, blockId) {
     alert('blockSelect Featured Collection');

    var $featuredCollectionSlider = $section.find('[data-featured-collection-slider]');
    var slideIndex = $('#shopify-section-' + blockId).data('promo-index');
    $featuredCollectionSlider.slick('slickGoTo', slideIndex, true, true);
  },
  unload: function unload($section) {
    alert('unload Featured Collection');


    var $slider = $section.find('.flickity-enabled');
    $slider.slick('unslick');
    // $('.featured-collection__nav--prev').off();
    // $('.featured-collection__nav--next').off();
  }
};


window.addEventListener('load', function () {
  Shopify.theme.jsFeaturedCollection.init($('.jsFeaturedCollection'));
}, false);